import { render, staticRenderFns } from "./tournamentNews.vue?vue&type=template&id=e0e32dee&scoped=true&"
import script from "./tournamentNews.vue?vue&type=script&lang=js&"
export * from "./tournamentNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e32dee",
  null
  
)

export default component.exports